<template>
  <div class="p-b-3">
    <pro-selection/>

    <div class="container p-x-2:mo d-flex jc-end p-r-5">
      <router-link
          :to="{
            name: 'jobrequest::overview',
            params: $route.params,
            query: $route.query,
          }"
          :disabled="!isValid"
          class="btn btn-large w-100:mo"
          selenium="next-button">
        Continue
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProSelection from './components/ProSelection';

export default {
  name: 'job-matches',
  components: {
    ProSelection,
  },
  computed: {
    ...mapGetters('jobrequest/matches', ['isValid']),
  },
};
</script>
